<template>
  <div class="online-table">
    <online-search-bar
      :search-params="searchData"
      @changeSearchParams="changeSearchParams"
      @search="search"
    ></online-search-bar>
    <div>
      <el-table
        style="width: 100%"
        size="medium"
        header-row-class-name="supervision-table-header"
        class="is-print-hide"
        border
        :data="tableData"
      >
        <el-table-column label="药品通用名" prop="drugName">
          <template #default="{ row: { drugName, riskType } }">
            <span>{{ `${drugName} ` }}</span>
            <el-tag type="danger" v-if="riskType == 1" size="mini">风险</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="规格" prop="drugSpec"></el-table-column>
        <el-table-column label="数量" prop="drugNum">
          <template #default="{ row: { drugNum, drugUnit } }">
            <span>{{ `${drugNum}${drugUnit || ''}` }}</span>
          </template>
        </el-table-column>
        <el-table-column label="诊断" prop="diagnose"></el-table-column>
        <el-table-column label="开方时间" prop="prescriptionTime" width="120"></el-table-column>
        <el-table-column label="用药人姓名" prop="patientName"></el-table-column>
        <el-table-column label="处方平台" prop="platformName"></el-table-column>
        <el-table-column label="医疗机构" prop="hospitalName"></el-table-column>
        <el-table-column label="处方编号" prop="prescriptionId"></el-table-column>
        <el-table-column label="操作">
          <template #default="{ row: { prescriptionId, creditCode } }">
            <el-button type="text" @click="gotoDetail(prescriptionId, creditCode)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @handlePage="handlePage"
        v-if="tableData && tableData.length"
        :total="pages.totalCount"
        :current-page="pages.pageNo"
        :page-size="pages.pageSize"
      />
    </div>
  </div>
</template>

<script>
import { mapRequestParamsEmpty2Null, shortcuts } from '@/util';
import dayjs from 'dayjs';
import onlineSearchBar from './onlineSearchBar';
import pagination from '../pagination';
import { mapGetters } from 'vuex';

export default {
  name: 'online',
  components: { onlineSearchBar, pagination },
  data() {
    return {
      searchData: {
        prescriptionId: '',
        drugName: '',
        riskType: this.$route.query.riskType || null,
        platformName: '',
        hospitalName: '',
        registrationTime: [
          dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
          dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
        ]
      },
      tableData: [],
      pages: { totalCount: 0, pageSize: 20, pageNo: 1 }
    };
  },
  computed: {
    ...mapGetters(['storeList']),
    storeId() {
      // 多店业务上暂时不考虑
      const { storeList } = this;
      return Array.isArray(storeList) ? storeList?.[0].id : storeList?.id;
    }
  },
  mounted() {
    this.initParams();
    this.loadMore();
  },
  methods: {
    initParams() {
      const { messageTime } = this.$route.query;

      if (messageTime) {
        const startTime = dayjs(Number(messageTime)).format('YYYY-MM-DD 00:00:00');
        const endTime = dayjs(Number(messageTime)).format('YYYY-MM-DD 23:59:59');
        this.searchData.registrationTime = [startTime, endTime];

        // this.$refs.searchModal.formInit(this.searchData);
      }
    },
    handleExport() {
      const [prescriptionStartTime = null, prescriptionEndTime = null] = this.searchData.registrationTime || [];
      this.$store.dispatch(
        'download/exportFile',
        mapRequestParamsEmpty2Null({
          exportType: 'exportOnlinePrescription',
          ...this.searchData,
          prescriptionStartTime,
          prescriptionEndTime
        })
      );
    },
    reset() {
      this.searchData = {
        prescriptionId: '',
        drugName: '',
        platformName: '',
        hospitalName: '',
        storeName: '',
        registrationTime: [
          dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
          dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
        ]
      };

      this.$refs.searchModal.formInit(this.searchData);
      this.pages.pageNo = 1;
      this.loadMore();
    },
    search() {
      this.pages.pageNo = 1;
      this.loadMore();
    },
    loadMore() {
      const {
        searchData,
        storeId,
        pages: { pageNo, pageSize }
      } = this;
      const params = {
        pageNo,
        pageSize,
        ...searchData
      };
      const [prescriptionStartTime = null, prescriptionEndTime = null] = params.registrationTime || [];
      Fetch.getElectronicPrescription(
        mapRequestParamsEmpty2Null({ ...params, storeId, prescriptionStartTime, prescriptionEndTime })
      ).then(({ data, totalCount }) => {
        this.pages.totalCount = totalCount;
        this.tableData = data;
      });
    },
    gotoDetail(prescriptionId, creditCode) {
      this.$router.push(`/prescription-supervision/detail?prescriptionId=${prescriptionId}&creditCode=${creditCode}`);
    },
    searchPlatformName: Fetch.getPlatformByName,
    handlePage(pageNo) {
      this.pages.pageNo = pageNo;
      this.loadMore();
    },
    changeSearchParams({ key, value }) {
      this.searchData[key] = value;
    }
  }
};
</script>

<style scoped></style>
